import { clearLandingTokenCache } from '@/api/landings-http';
import { clearSenderTokenCache } from '@/api/sender-http';
import { socket } from '@/api/socket';
import { $setConnectionPhase } from '@/entities/connection-entity';
import { $resetAuth } from '@/entities/profile-entity';
import { clearSessionKeeper } from '@/lib/session-keeper';
import { isSessionEndMessage, SESSION_END_MESSAGES } from '@/lib/session-messages';
import { toast } from 'sonner';

export { isSessionEndMessage, SESSION_END_MESSAGES };

type EndPanelSessionOptions = {
	navigate?: (path: string) => void;
	message?: string;
	showToast?: boolean;
};

export function endPanelSession(options: EndPanelSessionOptions = {}) {
	const { navigate, message, showToast = Boolean(message) } = options;

	clearSessionKeeper();
	$setConnectionPhase('online');
	$resetAuth();
	clearLandingTokenCache();
	clearSenderTokenCache();
	if (socket) {
		socket.disconnect();
	}
	if (showToast && message) {
		toast.error(message);
	}
	if (navigate) {
		navigate('/auth');
	} else if (typeof window !== 'undefined' && window.location.pathname !== '/auth') {
		window.location.assign('/auth');
	}
}
